import { bl_fi_entity_sales_credit_limit_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesCreditLimitContainerModel extends BaseContainerModel{
    bl_fi_entity_sales_credit_limit: bl_fi_entity_sales_credit_limit_RowClass=new bl_fi_entity_sales_credit_limit_RowClass();
}